export default "__VITE_ASSET__74138d78__"